export function CocoonMark({ className = "", letterClassName = "text-gradient-orange", withMind = false }) {
  if (!withMind) {
    return (
      <span className={`cocoon-mark ${className}`} role="img" aria-label="COCOON MIND">
        <span className={letterClassName} aria-hidden="true">COC</span>
        <span className="cocoon-orb" aria-hidden="true" />
        <span className="cocoon-orb cocoon-orb--2" aria-hidden="true" />
        <span className={letterClassName} aria-hidden="true">N</span>
      </span>
    );
  }
  return (
    <span className={`cocoon-lockup ${className}`} role="img" aria-label="COCOON MIND">
      <span className="cocoon-mark" aria-hidden="true">
        <span className={letterClassName}>COC</span>
        <span className="cocoon-orb" />
        <span className="cocoon-orb cocoon-orb--2" />
        <span className={letterClassName}>N</span>
      </span>
      <span className={`cocoon-mind ${letterClassName}`} aria-hidden="true">MIND</span>
    </span>
  );
}
